import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './tooltip.module.scss';

const Tooltip = ({ children, tip, align }) => (
  <span className={styles.tooltip}>
    <span className={cn(styles.tip, align === 'start' && styles.tipStart)}>
      {tip}
    </span>
    {children}
  </span>
);

Tooltip.defaultProps = {
  align: 'center',
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tip: PropTypes.string.isRequired,
  align: PropTypes.oneOf(['center', 'start']),
};

export default Tooltip;
